/**
 * Normaliza un número de WhatsApp para wa.me:
 * - Elimina espacios, guiones, paréntesis, +
 * - Si empieza con 0, lo reemplaza por 57 (Colombia)
 * - Asegura que sea string
 */
export function waLink(num, text) {
    if (!num) return '#'
    let n = String(num).replace(/[\s\-\(\)\+]/g, '')
    if (n.startsWith('0')) n = '57' + n.slice(1)
    const url = `https://wa.me/${n}`
    return text ? `${url}?text=${encodeURIComponent(text)}` : url
}

export function cleanWhatsapp(num) {
    if (!num) return ''
    let n = String(num).replace(/[\s\-\(\)\+]/g, '')
    if (n.startsWith('0')) n = '57' + n.slice(1)
    return n
}

const SOCIAL_BASES = {
    instagram: 'https://www.instagram.com/',
    facebook:  'https://www.facebook.com/',
    tiktok:    'https://www.tiktok.com/@',
}

export function normalizeSocial(social) {
    if (!social) return { instagram: null, facebook: null, tiktok: null, website: null }
    const out = { ...social }
    for (const [key, base] of Object.entries(SOCIAL_BASES)) {
        let v = out[key]
        if (!v) continue
        v = v.trim()
        if (v.startsWith('http://') || v.startsWith('https://')) continue
        v = v.replace(/^@/, '')
        out[key] = base + v
    }
    return out
}
